import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Firestore with settings to prevent timestamp errors
initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  experimentalForceLongPolling: true, // Add this to ensure better compatibility
});

// Get Firestore instance
export const db = getFirestore(app);

// Initialize and export Functions
// Use explicit region to match deployed Cloud Functions
export const functions = getFunctions(app, 'us-central1');

// Connect to Functions emulator when VITE_USE_EMULATOR is set (local dev only).
// Firestore stays on production so you work with real data.
if (import.meta.env?.VITE_USE_EMULATOR === 'true') {
  const emulatorPort = Number(import.meta.env?.VITE_FUNCTIONS_EMULATOR_PORT) || 5001;
  try {
    connectFunctionsEmulator(functions, '127.0.0.1', emulatorPort);
    console.log(`[Firebase] Connected to Functions emulator at 127.0.0.1:${emulatorPort}`);
  } catch {
    console.log('[Firebase] Functions emulator already connected');
  }
}

if (import.meta.env?.MODE !== 'production') {
  console.log('[Firebase] Using project:', firebaseConfig.projectId);
  if (import.meta.env?.VITE_USE_EMULATOR === 'true') {
    console.log('[Firebase] Functions → LOCAL EMULATOR (test Stripe keys)');
  } else {
    console.log('[Firebase] Functions → PRODUCTION (live Stripe keys)');
  }
}